import { SET_BULK_OPERATION_STATUS } from "../constants/bulkStatusConstants";

export const setBulkOperationStatus = (isBulk) => ({
  type: SET_BULK_OPERATION_STATUS,
  payload: isBulk
});